'use strict';

import Axios from 'axios';
import { parseResponseV3, handleError } from '@/_helpers/utils.js';
import qs from 'qs';

export default {
  fetchResponseAttributeValues(params) {
    let defaultParams = {
      with: ['attribute'],
      limit: 50,
      page: 1,
      filter: []
    };
    defaultParams.sort = [];
    defaultParams.sort['by'] = 'id';
    defaultParams.sort['order'] = 'desc';
    params = { ...defaultParams, ...params };
    if (params.with) {
      params.with = [...params.with, ...defaultParams.with];
    }
    if (isNaN(params.page)) {
      params.page = 1;
    }

    return new Promise((resolve, reject) => {
      Axios.get('/v3/response-attribute-values', {
        params,
        paramsSerializer: params => {
          return qs.stringify(params);
        }
      })
        .then(response => {
          resolve(parseResponseV3(response, 'values', params));
        })
        .catch(err => reject(handleError(err)));
    });
  }
};
